import React, {useEffect,useRef,useState} from 'react';
import {createPortal} from 'react-dom';
import PropTypes from 'prop-types';
import {useDispatch,useStore} from 'react-redux';
import ArchivedClientsDialog from './ArchivedClientsDialog';
import {ClientDetailApi,OpenClientDetailModal} from 'store/slices/clientSlice';
import {ownsClientDetailAction} from 'store/slices/clientDetailOwnership';

export default function ClientIdentityConflict({conflict,onClose,onResolved}) {
  const dispatch=useDispatch();const store=useStore();const alive=useRef(true);
  const [archives,setArchives]=useState(false);const [busy,setBusy]=useState(false);const [error,setError]=useState('');
  useEffect(()=>{alive.current=true;return()=>{alive.current=false;};},[]);
  const review=async id=>{
    if(busy)return;
    setBusy(true);setError('');
    const action=await dispatch(ClientDetailApi({id}));
    if(!alive.current)return;
    setBusy(false);
    if(action.meta?.requestStatus==='fulfilled' && ownsClientDetailAction(store.getState().client,action)){
      dispatch(OpenClientDetailModal('open'));onResolved();
    } else setError('The matching client could not be opened. Please retry.');
  };
  if(archives) return createPortal(<ArchivedClientsDialog initialQuery={conflict.email || ''}
    onClose={()=>setArchives(false)} onRestored={()=>{if(alive.current)onResolved();}}/>,document.body);
  const ids=[...new Set((conflict.client_ids || []).map(Number).filter(id=>Number.isSafeInteger(id) && id>0))];
  return createPortal(<div className="modal show" role="dialog" aria-modal="true" aria-label="Client identity needs review"
    style={{display:'block',background:'rgba(0,0,0,.45)',zIndex:1100}}>
    <div className="modal-dialog modal-dialog-centered"><div className="modal-content"><div className="modal-body">
      <div role="alert">{conflict.message}</div>
      {error && <p role="alert">{error}</p>}
      {conflict.action==='restore_or_reconcile' && <button type="button" className="btn btn-primary" onClick={()=>setArchives(true)}>Review archived client</button>}
      {conflict.action!=='restore_or_reconcile' && ids.map(id=><button key={id} type="button" className="btn btn-primary" disabled={busy} onClick={()=>review(id)}>Review matching client #{id}</button>)}
      <button type="button" className="btn btn-outline-secondary" disabled={busy} onClick={onClose}>Return to client form</button>
    </div></div></div>
  </div>,document.body);
}
ClientIdentityConflict.propTypes={
  conflict:PropTypes.shape({message:PropTypes.string,action:PropTypes.string,email:PropTypes.string,client_ids:PropTypes.arrayOf(PropTypes.number)}).isRequired,
  onClose:PropTypes.func.isRequired,onResolved:PropTypes.func.isRequired,
};
